import React from 'react';
import classnames from 'classnames';

import DataTable from '@components/DataTable/DataTable';

import styles from './Status.css';

import {
  COLUMNS,
  FOUNDATIONS_DATA,
  ELEMENTS_DATA,
  COMPONENTS_DATA,
} from './constants/statusData';

const foundationsColumns = [{ header: 'foundations', key: 'group'}, ...COLUMNS];
const elementsColumns = [{ header: 'elements', key: 'group'}, ...COLUMNS];
const componentsColumns = [{ header: 'components', key: 'group'}, ...COLUMNS];

const Status = () => (
  <section className={classnames(styles.statusTablesWrapper, 'black')}>
    <article>
      <DataTable
        columns={foundationsColumns}
        data={FOUNDATIONS_DATA}
      />
    </article>
    <article>
      <DataTable
        columns={elementsColumns}
        data={ELEMENTS_DATA}
      />
    </article>
    <article>
      <DataTable
        columns={componentsColumns}
        data={COMPONENTS_DATA}
      />
    </article>
  </section>
);

export default Status;



// WEBPACK FOOTER //
// ./src/containers/libraryStatus/Status.js